import api from 'api'
import { CACHE_TAG_ACCOUNT_DETAILS, CACHE_TAG_ACCOUNT_LIST } from 'api/cacheTagTypes'

import type { InsertAccountBody } from 'types/api/account/accountRequests'

type InsertAccountResponse = { id: string }

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    insertAccount: build.mutation<InsertAccountResponse, InsertAccountBody>({
      invalidatesTags: [CACHE_TAG_ACCOUNT_LIST, CACHE_TAG_ACCOUNT_DETAILS],
      query: body => ({ url: '/api/v1/core/accounts', method: 'POST', body }),
    }),
  }),
})

export const { useInsertAccountMutation } = extendedApi
